export default "__VITE_ASSET__BA36UE93__"